import { lazy } from 'react';
import { GiftFlow } from 'components/GiftFlow/GiftFlow/GiftFlow';
import MobileRoadblock from 'components/MobileRoadblock';
import About from 'pages/About';
import AlgoliaSearchBox from 'components/AlgoliaSearchBox';
import FacebookSettings from 'components/FacebookSettings';
import FooterWrapper from 'components/FooterWrapper';
import GeneralPrivacyPolicy from 'components/privacyPolicy/GeneralPrivacyPolicy';
import GlobalActions from 'components/GlobalActions';
import HomePage from 'pages/HomePage';
import LoginForm from 'components/forms/LoginForm';
import MobileHomeLink from 'components/NavigationWrapper/MobileHomeLink';
import NavigationWrapper from 'components/NavigationWrapper';
import Pro from 'components/Pro';
import ProfileSlidingTabs from 'components/profile/ProfileSlidingTabs';
import ProMarketingFeatures from 'components/ProMarketingFeatures';
import ProWelcome from 'components/ProWelcome';
import QuoteRotator from 'components/QuoteRotator';
import RedemptionPage from 'components/RedemptionPage';
import SignUpForm from 'components/forms/SignUpForm';
import UpdatePaymentForm from 'components/forms/UpdatePaymentForm';

import withSuspense from '../hocs/withSuspense';

const Mobile = lazy(() => import('../pages/Mobile'));

require('@alltrails/shared/sharedCss.css');

const ReactRailsUJS = require('react_ujs');

const context = {
  About,
  AlgoliaSearchBox,
  FacebookSettings,
  FooterWrapper,
  GeneralPrivacyPolicy,
  GiftFlow,
  GlobalActions,
  HomePage,
  LoginForm,
  Mobile: withSuspense(Mobile, 'Mobile'),
  MobileHomeLink,
  MobileRoadblock,
  NavigationWrapper,
  Pro,
  ProfileSlidingTabs,
  ProMarketingFeatures,
  ProWelcome,
  QuoteRotator,
  RedemptionPage,
  SignUpForm,
  UpdatePaymentForm
};

ReactRailsUJS.getConstructor = className => context[className];
